<template>
  <div>

  <service-synopsis
    :key="view"
    :view="view"
    :panels="panels"
    :service-garden="serviceGarden" />
  </div>
</template>

<script>
import ServiceSynopsis from 'components/service-synopsis'
import {PANELS, SERVICE_GARDENS} from 'app-constants'
export default {
  name: 'service-advertisement',
  components: {
    'service-synopsis': ServiceSynopsis
  },
  data () {
    return {
      panels: PANELS[this.$props.view.toUpperCase()],
      serviceGarden: SERVICE_GARDENS[this.$props.view.toUpperCase()]
    }
  },
  props: ['view']
}
</script>



// WEBPACK FOOTER //
// apps/www.bravenet.com/src/views/service-advertisement.vue